webpackJsonp([62],{

/***/ 1589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            sass: "\n                // Import Bulma's core\n                @import \"~bulma/sass/utilities/_all\";\n\n                // Set your colors\n                $primary: #8c67ef;\n                $primary-invert: findColorInvert($primary);\n                $twitter: #4099FF;\n                $twitter-invert: findColorInvert($twitter);\n\n                // Setup $colors to use as bulma classes (e.g. 'is-twitter')\n                $colors: (\n                    \"white\": ($white, $black),\n                    \"black\": ($black, $white),\n                    \"light\": ($light, $light-invert),\n                    \"dark\": ($dark, $dark-invert),\n                    \"primary\": ($primary, $primary-invert),\n                    \"info\": ($info, $info-invert),\n                    \"success\": ($success, $success-invert),\n                    \"warning\": ($warning, $warning-invert),\n                    \"danger\": ($danger, $danger-invert),\n                    \"twitter\": ($twitter, $twitter-invert)\n                );\n\n                // Links\n                $link: $primary;\n                $link-invert: $primary-invert;\n                $link-focus-border: $primary;\n\n                // Import Bulma and Buefy styles\n                @import \"~bulma\";\n                @import \"~buefy/src/scss/buefy\";\n                ",
            importing: "\n                import Vue from 'vue'\n                import Buefy from 'buefy'\n\n                Vue.use(Buefy)"
        };
    }
});

/***/ }),

/***/ 1590:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "media"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Install Buefy via npm")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "code": "npm install buefy",
      "lang": "bash",
      "expanded": ""
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Set your variables with Sass")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-info"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_c('b', [_vm._v("Tip:")]), _vm._v(" You can see "), _c('a', {
    attrs: {
      "href": "http://bulma.io/documentation/overview/variables/",
      "target": "_blank"
    }
  }, [_vm._v("all of Bulma's variables")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("There's also two other variables created by Buefy:")]), _vm._v(" "), _c('ol', [_c('li', [_c('code', [_vm._v("$speed-slow: 150ms !default")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("$speed-slower: 250ms !default")])])])])]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-warning"
    }
  }, [_vm._v("\n                    You might also have to install "), _c('code', [_vm._v("node-sass")]), _vm._v(" and "), _c('code', [_vm._v("sass-loader")]), _vm._v(" depending on your environment.\n                ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "example is-paddingless"
  }, [_c('CodeView', {
    attrs: {
      "code": _vm._f("pre")(_vm.sass),
      "lang": "sass",
      "expanded": ""
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Import and use Buefy")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-warning"
    }
  }, [_vm._v("\n                    Please note that "), _c('code', {
    staticClass: "javascript"
  }, [_vm._v("import 'buefy/dist/buefy.css'")]), _vm._v(" from the "), _c('router-link', {
    attrs: {
      "to": "/documentation/start"
    }
  }, [_vm._v("start section")]), _vm._v(" has been omitted.\n                ")], 1), _vm._v(" "), _c('CodeView', {
    attrs: {
      "code": _vm._f("pre")(_vm.importing),
      "lang": "javascript",
      "expanded": ""
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("Or clone the repository: "), _c('a', {
    attrs: {
      "href": "https://github.com/buefy/buefy",
      "target": "_blank"
    }
  }, [_vm._v("https://github.com/buefy/buefy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "block"
  }, [_vm._v("\n                    It can be done in your "), _c('b', [_vm._v("App.vue")]), _vm._v(" within the "), _c('code', [_vm._v("<style lang=\"scss\">")]), _vm._v(" tag, or in a separate "), _c('b', [_vm._v(".scss")]), _vm._v(" file.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("3")])])
}]}

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1589),
  /* template */
  __webpack_require__(1590),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/62.6ef379e3b80f1a492f43.js